<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/6.png" />
      <div class="marginLeft15">产品登记</div>
    </div>
    <Plan class="successController marginTop20">
      <div class="infoController">
        <img class="ico" src="@/assets/img/gou.png" />
        <div class="text marginLeft20">
          <div class="title">您的信息提交成功，需等待审核</div>
          <div class="des">
            如有疑问请联系
            <span class="tel">
              13529375479 15887247294
            </span>
          </div>
        </div>
      </div>
      <div style="text-align: center;">
        <div
          @click="
            $router.push({
              query: {
                uuid: uuid,
                onlyshow: 1
              },
              name: 'ProductSave'
            })
          "
          class="subBtnController"
        >
          查看进度
        </div>
      </div>
    </Plan>
  </div>
</template>
<script>
import Plan from "@/components/Plan.vue";
export default {
  data() {
    return {
      uuid: null,
      savetype: null
    };
  },
  async mounted() {
    // 判断当前的修改模式
    if (this.$route.query.savetype) {
      this.savetype = this.$route.query.savetype;
    }
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
  },
  components: {
    Plan
  }
};
</script>
<style lang="less" scoped>
.successController {
  .infoController {
    margin: auto;
    margin-top: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
    .ico {
      width: 40px;
      height: 40px;
      opacity: 1;
    }
    .text {
      .title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .des {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        opacity: 1;
        .tel {
          color: rgba(0, 177, 255, 1);
        }
      }
    }
  }
  .subBtnController {
    margin-top: 128px;
    margin-bottom: 55px;
  }
}
</style>
